import { theme } from "antd";

// Get the current theme instance
export const { useToken } = theme;

// Custom color constants
export const CUSTOM_COLORS = {
	PINK: "#F72586",
	LIGHT_BLUE: "#4BC9F1",
	PRIMARY: "#3A0CA3",
	SECONDARY: "#4460EF",
} as const;

// Color variations
export const COLOR_VARIATIONS = {
	primary: {
		main: CUSTOM_COLORS.PRIMARY,
		hover: "#4A1CB3",
		active: "#2A0C93",
		light: "#F0EDF9",
		lighter: "#F7F5FC",
	},
	pink: {
		main: CUSTOM_COLORS.PINK,
		hover: "#E01A7A",
		active: "#C6156E",
		light: "#FFE5F2",
		lighter: "#FFF0F8",
	},
	lightBlue: {
		main: CUSTOM_COLORS.LIGHT_BLUE,
		hover: "#3AB8E1",
		active: "#29A7D1",
		light: "#E5F8FD",
		lighter: "#F0FBFF",
	},
} as const;

/** Semantic colors shared by the app's button variants. */
export const BUTTON_COLORS = {
	text: "#303030",
	surface: "#FFFFFF",
	neutralBorder: "#D9D9D9",
	neutralBorderHover: "#BFBFBF",
	neutralText: "#666666",
	neutralHover: "#F5F5F5",
	neutralActive: "#EBEBEB",
	disabledBackground: "#ECECEC",
	disabledBorder: "#8C8C8C",
	disabledText: "#8C8C8C",
	danger: "#FF4D4F",
	dangerBackground: "#FFF1F0",
	dangerHover: "#FFCCC7",
	dangerActive: "#FFA39E",
	focusRing: "rgba(58, 12, 163, 0.28)",
} as const;

// Helper function to get CSS variable value
export const getCSSVariable = (variableName: string): string => {
	return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
};

// Helper function to use custom colors in styled-components or inline styles
export const getCustomColor = (
	colorName: keyof typeof COLOR_VARIATIONS,
	variant: keyof (typeof COLOR_VARIATIONS)[keyof typeof COLOR_VARIATIONS] = "main",
): string => {
	return COLOR_VARIATIONS[colorName][variant];
};
